import { Reveal } from "@/components/site/Reveal";

// Shared section heading: eyebrow + H2 + optional supporting copy.
// One typography rhythm across every page.
export const SectionIntro = ({ eyebrow, title, body, className = "", center = false }) => (
  <Reveal className={`${center ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}>
    {eyebrow && (
      <span className="text-xs font-semibold uppercase tracking-widest text-teal">{eyebrow}</span>
    )}
    <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-navy md:text-4xl">{title}</h2>
    {body && <p className="mt-4 text-bodygrey">{body}</p>}
  </Reveal>
);

export default SectionIntro;

